/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { withTranslation } from 'react-i18next';
import { UPSERT_ACTIVITY_NOTES } from '../../graphql/queries';
import { logger } from '../../logger';

const styles = () => ({
  root: {},
});

class NotesForm extends React.Component {
  constructor(props) {
    super(props);

    if (props.notes) {
      this.state = {
        notes: props.notes,
      };
    } else {
      this.state = {
        notes: '',
      };
    }

    this.state.saved = true;
  }

  handleChange = (event, channel, upsertActivityNotes) => {
    this.setState({ saved: false });
    this.setState({ [event.target.name]: event.target.value });
    upsertActivityNotes({ variables: { channel, notes: this.state.notes } }).then(() => {
      this.handleSave();
    });
  };

  handleSave = () => {
    this.setState({ saved: true });
  };

  render() {
    const { classes, channel, t } = this.props;

    return (
      <div>
        <div>
          <Mutation
            mutation={UPSERT_ACTIVITY_NOTES}
            // refetchQueries={() => [{ query: GET_ACTIVITY_BY_CHANNEL, variables: { channel } }]}
          >
            {(upsertActivityNotes) => (
              <div>
                <ValidatorForm onError={(errors) => logger.error(errors)} className={classes.form}>
                  <Grid container spacing={8}>
                    <Grid item xs={12}>
                      <TextField
                        id="notes"
                        label={t('Common_RuntimeView_Command_Notes')}
                        fullWidth
                        multiline
                        className={classes.textField}
                        margin="normal"
                        onChange={(e) => {
                          this.handleChange(e, channel, upsertActivityNotes);
                        }}
                        name="notes"
                        value={this.state.notes}
                      />
                    </Grid>
                  </Grid>
                </ValidatorForm>
              </div>
            )}
          </Mutation>
        </div>
      </div>
    );
  }
}

NotesForm.propTypes = {
  classes: PropTypes.object.isRequired,
  notes: PropTypes.object.isRequired,
  channel: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(styles)(NotesForm));
